import { useEffect, useState } from 'react'

import { commonService } from '../services'

const useUserNationalities = () => {
  const [data, setData] = useState<any[] | null>(null)

  useEffect(() => {
    getUserNationalities()
  }, [])

  const getUserNationalities = async () => {
    const resp: any = await commonService.getNationalities()
    setData(resp.data)
  }

  return {
    data
  }
}

export { useUserNationalities }